// @flow

import * as React from 'react';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import NoRecord from 'components/NoRecord/NoRecord';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import type { L10n } from 'type/type';
import { getLocale } from 'modules/app/selector';
import { getSearchedParticipants } from 'scenes/Event/duck/selector';
import { isKioskMode } from 'services/kiosk/kiosk';

import SearchParticipantListItem from './SearchParticipantListItem/SearchParticipantListItem';
import { searchParticipant } from '../duck/duck';
import { getApplicationName } from '../duck/selector';
import ViewMore from './ViewMore/ViewMore';

type Props = {
  loading: boolean,
  participants: [],
  locale: string,
  listLength: number,
  total: number,
  keyword: string,
  applicationName: string,
  onViewMore: () => void,
  l10n: L10n
}

export const SearchParticipants = ({
  loading,
  participants,
  locale,
  listLength,
  total,
  onViewMore,
  keyword,
  applicationName,
  l10n,
}: Props) => {
  const isKiosk = isKioskMode(window);
  const { search } = window.location;

  return (
    participants && participants.length > 0
      ? <ViewMore
        length={listLength}
        total={total}
        loading={loading}
        keyword={keyword}
        applicationName={applicationName}
        label={l10n.formatMessage('page.event.participant.search.loadMore')}
        onViewMore={onViewMore} >
        <ul className="list-unstyled">
          {participants.map(p => (
            <SearchParticipantListItem
              key={p.participantId}
              locale={locale}
              isKioskMode={isKiosk}
              queryString={search}
              {...p} />
          ))}
        </ul>
      </ViewMore>
      : <NoRecord hint={l10n.formatMessage('page.event.participant.search.noData')} />
  );
};

const mapState = (state) => {
  return {
    locale: getLocale(state),
    participants: getSearchedParticipants(state),
    applicationName: getApplicationName(state),
    loading: state.getIn([ 'eventPage', 'loadingSearchedParticipants' ]),
    listLength: state.getIn([ 'eventPage', 'displayRecordsLength' ]),
    total: state.getIn([ 'eventPage', 'total' ]),
    keyword: state.getIn([ 'eventPage', 'keyword' ]),
  };
};

const mapDispatch = (dispatch) => {
  return {
    onViewMore: (length, keyword, applicationName) => dispatch(
      searchParticipant(
        keyword,
        applicationName,
        length + 1,
      ),
    ),
  };
};

export default injectL10n()(connect(mapState, mapDispatch)(SearchParticipants));
